export default __webpack_public_path__ + "static/media/xml.f6508dea.png";